import React from "react";
import styled from "styled-components";

import { NavigationLinks } from "./Styles";
import Icons from "./Icons";

const IconWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

const Redes = () => {
    return (
        <IconWrapper>
            <NavigationLinks
                href="https://www.instagram.com/dra.manuelitaelias/"
                title="Instagram"
                target="_blank"
                rel="noreferrer"
            >
                <Icons name="instagram" />
            </NavigationLinks>
            <NavigationLinks
                href="https://ar.linkedin.com/in/manuelita-elias-210518379/"
                title="Linkedin"
                target="_blank"
                rel="noreferrer"
            >
                <Icons name="linkedin" />
            </NavigationLinks>
            <NavigationLinks
                href="https://www.facebook.com/p/Dra-Manuelita-Elias-100063582216672/"
                title="Facebook"
                target="_blank"
                rel="noreferrer"
            >
                <Icons name="facebook" />
            </NavigationLinks>
        </IconWrapper>
    );
};

export default Redes;
